export enum userTypes {
  Admin = '1',
  Student = '2',
}
